import React from 'react';
import Workflow from "./components/workflow";

const WorkflowCreate = () => {
  return (
    <Workflow />
  )
}

WorkflowCreate.auth = {
    path: "/workflows/create",
    role: "super-admin admin",
  };

export default WorkflowCreate;